<template>
  <div @click="copyText()" class="cursor-pointer">
    <p class="small text-muted m-0">
      <span v-if="copied" class="text-success">Copiado!</span>
      <i class="fa-solid fa-copy fa-lg" v-else></i>
    </p>
  </div>
</template>

<script>
export default {
  name: "CopyText",
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      copied: false,
    };
  },
  methods: {
    async copyText() {
      try {
        this.copied = true;
        await navigator.clipboard.writeText(this.text);

        setTimeout(() => {
          this.copied = false;
        }, 3000);
      } catch (error) {
        console.error("Erro ao copiar texto:", error);
        this.copied = false;
      }
    },
  },
};
</script>
